<template>
  <div class="page-honor">
    <div class="content-wrap">
      <h1 class="h1 color-black">荣誉学生评选标准</h1>
      <h2 class="h2 color-gray-1 mt-30">参与对象</h2>
      <p class="text1 color-gray-2 mt-10">
        所有参加本届峰会的学⽣都将⾃动被纳⼊荣誉毕业⽣考察范围，⽆需额外申请。荣誉学生和最高荣誉学生的设置，是为了表彰和鼓励在峰会学术体系获得优异成绩，并能遵守峰会规范准则的学生。荣誉和最高荣誉学生的结果将会与峰会成绩⼀起在9⽉中公布，请留意届时的邮件通知。
      </p>
      <h2 class="h2 color-gray-1 mt-30">评选标准</h2>
      <p class="text1 color-gray-2 mt-10">
        峰会里的荣誉评定，主要由你的 GPA
        相对排名决定，在完成毕业基本学术要求以外，必须达到荣誉学生学术要求，并主动遵守行为准则，积极参与峰会中的各项活动。荣誉（Honor）的比例为本场次所有学生排名的前8%，最高荣誉（High
        Honor）的比例前3%，同时还会兼顾考量你在峰会和House活动里的参与情况和行为表现。你需要⽐别⼈完成得更加出⾊，才有可能成为峰会的“荣誉毕业⽣”。
      </p>
      <div class="points-wrap mt-30">
        <div class="item">
          <div class="title-wrap h3 color-gray-1">
            <div class="title-content">评选要求</div>
          </div>
          <div class="item-content">
            <ul class="ul color-gray-2 text1">
              <li>平均GPA不低于3.8（满分4.0）</li>
              <li>Honor：总排名位列于所有2022届学生的前8%；</li>
              <li>High Honor：总排名位列于所有2022届学生的前1-3%且所有打分制课程（Seminar & Capstone）取得A或A+等级；</li>
              <li>
                峰会三个场次期间（7月19日-8月22日）共参加3次Cornerstone Workshop大学能力强化课
              </li>
            </ul>
          </div>
        </div>
        <div class="item">
          <div class="title-wrap h3 color-gray-1">
            <div class="title-content">行为准则</div>
          </div>
          <div class="item-content">
            <ul class="ul color-gray-2 text1">
              <li>不违反任何峰会纪律规定，主动遵守行为准则，给同学和⽼师留下良好的印象。</li>
              <li>积极参与House团队建设和活动比拼，为House荣誉作出自己的贡献。</li>
            </ul>
          </div>
        </div>
        <div class="item">
          <div class="title-wrap h3 color-gray-1">
            <div class="title-content">加分项</div>
          </div>
          <div class="item-content">
            <ul class="ul color-gray-2 text1">
              <li>主动申请 HSYLC÷ 中的更多挑战，比如成为SSI、入选HAA校园大使、申请并入选SBP等；</li>
              <li>积极参加峰会期间的各项活动，例如师生对话时间 Office Hour、兴趣社团HSYLC Interest Hub、学院杯 House Cup、House Game等；</li>
              <li>如果出现多个成绩相同的学生而荣誉比例有限，则荣誉学生和最高荣誉学生将优先给予在加分项中更积极参与的学生。</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import './index.less';
export default {
  name: 'Honor',
  async created() {
    await this.$initPaidRedirect();
  }
};
</script>
